import { Slider } from '../card-slider/slider.js';

export class PeopleSlider extends Slider {
	constructor(
		node,
		config = {
			back: '.card-slider__go--back',
			forward: '.card-slider__go--forward',
			content: '.people__layout',
			items: '.people__layout > *',
			sticky: false,
		}
	) {
		super( node, config );
	}

}

document.addEventListener( 'DOMContentLoaded', () => {
	for ( const node of document.querySelectorAll( '.people--slider:not( .people-tabs .people--slider )' ) ) {
		new PeopleSlider( node );
	}
} );
